import { ReactNode } from "react";

interface SEOArticleStructureProps {
  children: ReactNode;
  title: string;
  description: string;
  author?: string;
  datePublished?: string;
  dateModified?: string;
  keywords?: string[];
  className?: string;
}

export const SEOArticleStructure = ({
  children,
  title,
  description,
  author = "Luis ROC",
  datePublished,
  dateModified,
  keywords = [],
  className = ""
}: SEOArticleStructureProps) => {
  return (
    <article 
      className={className}
      itemScope 
      itemType="https://schema.org/Article"
    >
      {/* Hidden metadata for search engines */}
      <div className="sr-only">
        {/* No es un H1: el H1 visible vive en la página (evita H1 duplicado) */}
        <span itemProp="headline">{title}</span>

        <p itemProp="description">{description}</p>
        <span itemProp="author" itemScope itemType="https://schema.org/Person">
          <span itemProp="name">{author}</span>
        </span>
        {datePublished && (
          <time itemProp="datePublished" dateTime={datePublished}>
            {new Date(datePublished).toLocaleDateString()}
          </time>
        )}
        {dateModified && (
          <time itemProp="dateModified" dateTime={dateModified}>
            {new Date(dateModified).toLocaleDateString()}
          </time>
        )}
        {keywords.length > 0 && (
          <meta itemProp="keywords" content={keywords.join(', ')} />
        )}
        <span itemProp="publisher" itemScope itemType="https://schema.org/Organization">
          <span itemProp="name">ROC Worldwide Agency LLC</span>
          <meta itemProp="url" content="https://luisroc.com" />

        </span>
      </div>
      
      {/* Visible content */}
      <div itemProp="articleBody">
        {children}
      </div>
    </article>
  );
};
